/**
 * AreaImagesSection – Area images using the canonical MediaImageManager.
 * Uses owner_type='area' so media_assets are correctly scoped.
 */

import { MediaImageManager } from '@/components/media/MediaImageManager';
import { useMediaUpload } from '@/hooks/useMediaUpload';

interface AreaImagesSectionProps {
  areaId?: string | null;
  draftSessionId?: string;
}

export function AreaImagesSection({
  areaId,
  draftSessionId,
}: AreaImagesSectionProps) {
  const effectiveOwnerId = areaId || undefined;
  const effectiveDraftSessionId = draftSessionId ?? '';

  const coverUpload = useMediaUpload({
    ownerType: 'area',
    ownerId: effectiveOwnerId ?? null,
    draftSessionId: !effectiveOwnerId ? effectiveDraftSessionId : undefined,
    kind: 'cover',
    maxFiles: 1,
  });

  const galleryUpload = useMediaUpload({
    ownerType: 'area',
    ownerId: effectiveOwnerId ?? null,
    draftSessionId: !effectiveOwnerId ? effectiveDraftSessionId : undefined,
    kind: 'gallery',
    maxFiles: 12,
  });

  return (
    <MediaImageManager
      ownerType="area"
      ownerId={effectiveOwnerId}
      draftSessionId={effectiveDraftSessionId}
      coverUpload={coverUpload}
      galleryUpload={galleryUpload}
      helperText="Ladda upp omslagsbild och galleri för området."
    />
  );
}
